<template>
  <div id="content">
    <p v-if="error">{{error}}</p>
    <div v-if="!app">
      <p>Loading...</p>
    </div>
    <div v-else>
      <!-- Loaded -->
      <h1>{{app.name}}</h1>
      <p>{{app.onelinedesc}}</p>

      <h2>動作環境</h2>
      <p v-html="app.platformdesc"></p>

      <div v-if="app.screenshot">
        <h2>スクリーンショット</h2>
        <a :href="app.screenshot" target="_blank">
          <img :src="app.screenshot" />
        </a>
      </div>

      <div v-if="app.howto">
        <h2>使い方</h2>
        <span v-html="app.howto"></span>
      </div>

      <div v-if="app.howtolink">
        <h2>使い方</h2>
        <a :href="app.howtolink" target="_blank">こちら</a>をご覧ください。
      </div>
      
      <div v-if="app.downloaddesc">
        <h2>ダウンロード</h2>
        <p v-html="app.downloaddesc"></p>
      </div>

      <h2>履歴</h2>
      <b-textarea v-model="app.history" rows="10"></b-textarea>

      <div v-if="app.devdesc">
        <h2>開発</h2>
        <p v-html="app.devdesc"></p>
      </div>

      <div v-if="app.acknowledgement">
        <h2>謝辞</h2>
        <span v-html="app.acknowledgement"></span>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AppPage",
  data() {
    return {
      app: null,
      error: ""
    };
  },
  created() {
    var url = this.$func.getApiJsonUrl()
    console.log(url)
    axios
      .get(url)
      .then(res => {
        let appsData = res.data;
        console.log(appsData);
        this.app = appsData.find(app => {
          console.log(app.name);
          return app.name === this.appName;
        });
      })
      .catch(err => {
        console.log(err);
        this.error = err;
      });
  },
  computed: {
    appName() {
      return this.$route.params.appname;
    }
  }
};
</script>

<style scoped>
div#content {
  margin: 10px;  
}

h2 {
  margin-top: 20px;
}
img {
  width: 540px;
}
</style>
